import React from 'react'
import Icon from '@/modern/components/Icon'
import useFavorites from '@/modern/actions/useFavorites'
import PropTypes from 'prop-types'
import { Favorite } from './style'

const FavoriteDA = ({ id, vehicleType, details }) => {
  const { checkIfCardWasFavorited, setFavoriteItem } = useFavorites()
  const dataTestLabel = 'favorite'
  const dataTestLabelId = `${dataTestLabel}_${id}`
  const filled = checkIfCardWasFavorited(id)
  const heart = {
    color: filled ? '#f3123c' : '#686976',
    icon: filled ? 'Heart_2' : 'Heart_1',
  }

  const handleClick = () => {
    setFavoriteItem({ id, type: vehicleType, wasFavorited: filled, details })
  }

  return (
    <Favorite
      data-test-component={dataTestLabel}
      data-test-id={dataTestLabelId}
      wasFilled={filled}
      onClick={handleClick}
    >
      <Icon name={heart.icon} fill={heart.color} size="24" />
    </Favorite>
  )
}

FavoriteDA.propTypes = {
  id: PropTypes.string.isRequired,
  vehicleType: PropTypes.string.isRequired,
}

export default FavoriteDA
